export default "__VITE_ASSET__DSzVu_C___"